import { Instruction } from './Instruction'
import { InstructionTypes } from '../../Constants'

export class ShippingMethodInstruction extends Instruction {
  constructor ({ name, value }) {
    super({
      name: name || 'ShippingMethod',
      waitForNoLoaders: true,
      type: InstructionTypes.ShippingMethod

    })
    this.value = value
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.value === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    this.value = params.serviceType.description
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      value: this.value
    }
  }
}
